// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3E60z","col":"styles_col__3xiqd"};